import React from 'react';
import { TextLink } from '@tt2/components';
import transl from 'src/utils/translate';
import { PRIVACY_POLICY_URL } from 'src/constants';

export type NewsletterConsentTextProps = {
  short?: boolean;
};

export const NewsletterConsentText: React.FC<NewsletterConsentTextProps> = ({ short = false }) => (
  <span data-test-id="newsletter-consent-text">
    {transl(short ? 'Newsletter.Consent.TextShort' : 'Newsletter.Consent.Text')}{' '}
    <TextLink
      onClick={() => window.open(PRIVACY_POLICY_URL, '_blank', 'noopener,noreferrer')}
      data-test-id="newsletter-privacy-policy"
    >
      {transl('Newsletter.Consent.PrivacyPolicy')}
    </TextLink>
    .
  </span>
);

export default NewsletterConsentText;
